.key {
  padding: 2px 4px;
  border-radius: 4px;
  background: var(--dugout);
  box-shadow: inset 0 0 0 1px var(--outline);
}
